export default __webpack_public_path__ + "static/media/team2.74097254.png";